import { render, staticRenderFns } from "./LinkToJsonButton.vue?vue&type=template&id=0feb5533&"
import script from "./LinkToJsonButton.vue?vue&type=script&lang=js&"
export * from "./LinkToJsonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports